module.exports = __webpack_public_path__ + "img/locked-bg.46348c2a.svg";